<template>
  <div>
    <span
      class="pointer"
      v-for="(route, index) in routeBack"
      v-bind:key="index"
      v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
      v-on:click="goBack(route, index)">
     <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
    </span>
    <hr>
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <br>
    <h5>Marktnummer: 8045 - Rewe Markt Dagli</h5>
    <div class="alert alert-warning" v-if="!$online && upload">
      <span>
        <center>
          <v-icon size="25">error</v-icon>
          <b>Internetverbindung benötigt um Daten hochzuladen!</b>
          <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="row">
      <div
        class="col-xs-12 col-md-12 col-xl-6"
        v-for="bereich in bereiche"
        v-bind:key="bereich.bereichsnummer"
        v-on:click="gotoBereich(bereich.path, bereich.title)">
        <div class="card" id="bereiche">
          <div class="card-header" id="header">
            <h5 class="card-title" id="title">
               <i :class="bereich.icon"></i> {{ bereich.title }}
              <v-chip v-if="bereich.newDataSets" id="graphbutton">
                {{ bereich.newDataSets }}
                <v-icon right color="green" v-if="$online">cloud_upload</v-icon>
                <v-icon right v-else>cloud_upload</v-icon>
              </v-chip>
            </h5>
            <p class="card-category tablecard" id="subtitle">
              {{ bereich.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../../../store/store';
import navigation from '../../../store/navigation';

export default {
  data() {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      routeBack: [],
      upload: false,
      bereiche: [
        {
          bereichsnummer: 1,
          title: "Checklisten",
          subtitle: "Reinigungsnachweise etc.",
          icon: "ti-check-box",
          path: "servicelisten/checklists",
          newDataSets: 0,
        },
        {
          bereichsnummer: 2,
          title: "Heiße Theke",
          subtitle: "Temperaturlogs und Timer der Artikel",
          icon: "ti-time",
          path: "servicelisten/heissetheke",
          newDataSets: 0,
        },
        {
          bereichsnummer: 3,
          title: "OrgaInvent",
          subtitle: "",
          icon: "ti-notepad",
          path: "servicelisten/orgainvent",
          newDataSets: 0,
        },
        {
          bereichsnummer: 4,
          title: "Wareneingang",
          subtitle: "Temperaturkontrolle",
          icon: "ti-write",
          path: "servicelisten/wareneingang/temperatur",
          newDataSets: 0,
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
    goBack(route, index) {
      if (route !== "servicelisten") {
        this.$router.push({path: navigation.createNav(route).path});
      }
    },
    gotoBereich(route, title) {
      this.$router.push({path: route, query: { title: title}});
    },
  },
  created: function() {
    store.needUpload();
    if (store.uploadReinigungsnachweis || store.uploadTemperatur) {
      this.upload = true;
      this.bereiche[1].newDataSets = store.countReinigungsnachweis;
    }
    this.routeBack = navigation.createNav('servicelisten').params;
    // typeof this.$route.query.routeBack === 'object' ? this.routeBack = this.$route.query.routeBack : 
    //   (this.$route.query.routeBack !== undefined ? this.routeBack.push(this.$route.query.routeBack) : this.routeBack = '');
    // this.routeBack = [...this.routeBack, this.$route.name];
  }
};
</script>
<style scoped>
#frame {
  margin-left: 0%;
  margin-top: 0%;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
}
#bereiche:hover {
  cursor: pointer;
}
#subtitle {
  padding-left: 6px;
}

.backBar:hover {
  cursor: pointer;
  text-decoration: underline;
  color: red;
}
.pointer {
  cursor: default;
}

.Alarm {
  color: white;
}
</style>